export const locationIcon = require("../assets/location3.png");
export const timeIcon = require("../assets/image_Time.png");
export const calendarIcon = require('../assets/calanderLogo.png');
